<template>
  <div class="pagination">
    <div
      class="pagination__chervron-left"
      :class="{ disabled: isShowingFirstPage }"
      @click="onClickPage(currentPage - 1)"
    >
      <span class="tl-link-chevron-back--left" />
    </div>
    <div class="pagination__numbers">
      <div
        v-if="showableFirstPageLink"
        class="pagination__number"
        @click="onClickPage(1)"
      >
        <p>1</p>
      </div>
      <div v-if="showableForwardPageRange" class="pagination__range">...</div>
      <div
        v-if="showableTwoBeforePageLink"
        class="pagination__number"
        @click="onClickPage(currentPage - 2)"
      >
        <p>{{ currentPage - 2 }}</p>
      </div>
      <div
        v-if="!isShowingFirstPage && !isShowingNextOfFirstPage"
        class="pagination__number"
        @click="onClickPage(currentPage - 1)"
      >
        <p>{{ currentPage - 1 }}</p>
      </div>
      <div class="pagination__number--active">
        <p>{{ currentPage }}</p>
      </div>
      <div
        v-if="!isShowingLastPage && !isShowingPreviousOfLastPage"
        class="pagination__number"
        @click="onClickPage(currentPage + 1)"
      >
        <p>{{ currentPage + 1 }}</p>
      </div>
      <div
        v-if="showableTwoAfterPageLink"
        class="pagination__number"
        @click="onClickPage(currentPage + 2)"
      >
        <p>{{ currentPage + 2 }}</p>
      </div>
      <div v-if="showableBackwardPageRange" class="pagination__range">...</div>
      <div
        v-if="showableLastPageLink"
        class="pagination__number"
        @click="onClickPage(totalPages)"
      >
        <p>{{ totalPages }}</p>
      </div>
    </div>
    <div
      class="pagination__chervron-right"
      :class="{ disabled: isShowingLastPage }"
      @click="onClickPage(currentPage + 1)"
    >
      <span class="tl-link-chevron-forward--right" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    isShowingFirstPage() {
      return this.currentPage === 1
    },
    isShowingNextOfFirstPage() {
      return this.currentPage === 2
    },
    isShowingPreviousOfLastPage() {
      return this.currentPage === this.totalPages - 1
    },
    isShowingLastPage() {
      return this.currentPage === this.totalPages
    },
    showableFirstPageLink() {
      return !this.isShowingFirstPage
    },
    showableForwardPageRange() {
      return this.currentPage > 3 && this.totalPages > 4
    },
    showableTwoBeforePageLink() {
      return this.isShowingLastPage && this.currentPage > 3
    },
    showableTwoAfterPageLink() {
      return this.isShowingFirstPage && this.currentPage < this.totalPages - 2
    },
    showableBackwardPageRange() {
      return this.currentPage < this.totalPages - 2 && this.totalPages > 4
    },
    showableLastPageLink() {
      return !this.isShowingLastPage
    }
  },
  methods: {
    onClickPage(page) {
      this.$emit('clicked', page)
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  margin: auto;
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
  width: $small-contents-width;

  %number {
    color: $link;
    font-size: 1.6rem;
    line-height: 1.6;
    cursor: pointer;
  }

  &__chervron-left {
    @extend %number;
    margin: auto 20px auto 8px;
  }

  &__chervron-right {
    @extend %number;
    margin: auto 8px auto 20px;
  }

  &__numbers {
    display: flex;
  }

  &__number {
    @extend %number;
    margin: auto 16px;

    & p {
      width: 17.8px;
      height: 25px;
      text-align: center;
    }

    &--active {
      @extend .pagination__number;
      margin: auto 8px;
      padding: 4px 8px;
      background-color: $gray-2;
      border-radius: 50%;
    }
  }

  &__range {
    margin: auto 0;
  }

  .disabled {
    visibility: hidden;
  }
}

@media screen and (max-width: $small-contents-width - 1px) {
  .pagination {
    width: 320px;

    &__chervron-left,
    &__chervron-right {
      margin: auto 8px;
    }

    &__number {
      margin-left: 15px;
      margin-right: 15px;

      &--active {
        margin-left: 3px;
        margin-right: 3px;
      }
    }
  }
}
</style>
